import React from 'react';

export const CopilotLineGraphTickLabelsView = () => {
  return (
    <div id="graph-labels">
      <div className="flex justify-between pl-[40px] pr-[20px] text-gray-600">
        <div className="font-sans text-xs font-normal">0</div>
        <div className="font-sans text-xs font-normal">10%</div>
        <div className="font-sans text-xs font-normal">20%</div>
        <div className="font-sans text-xs font-normal">30%</div>
        <div className="font-sans text-xs font-normal">40%</div>
        <div className="font-sans text-xs font-normal">50%</div>
        <div className="font-sans text-xs font-normal">60%</div>
        <div className="font-sans text-xs font-normal">70%</div>
        <div className="font-sans text-xs font-normal">80%</div>
        <div className="font-sans text-xs font-normal">90%</div>
        <div className="font-sans text-xs font-normal">100%</div>
      </div>
    </div>
  );
};
